import { gql } from '@apollo/client';

/** Paginated user list query with filter args + cursor. */
export const GET_USERS_PAGE = gql`
  query GetUsersPage($input: GetUsersPageRequest!) {
    getUsersPage(input: $input) {
      metadata {
        status
        errors
        tracking_id
      }
      result {
        users {
          id
          created
          modified
          deleted
          first_name
          last_name
          email
          phone
          super_admin
          groups
          type
          last_accessed
          invitation_status
          invitation_sent_at
          invitation_token_state
          welcome_email_sent_at
          welcome_email_kind
        }
        nextCursor
      }
    }
  }
`;

export const CHECK_EXISTING_EMAILS = gql`
  query CheckExistingEmails($input: CheckExistingEmailsRequest!) {
    checkExistingEmails(input: $input) {
      metadata {
        status
        errors
        tracking_id
      }
      result
    }
  }
`;
